import React, { Fragment, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Menu, Dropdown } from "antd";
import { DownOutlined, UserOutlined, LogoutOutlined } from "@ant-design/icons";
import { getUserProfile, userLogout } from "../service/auth";
import routesService from "../service/routeService";
const UserBox = (_) => {
	const [email, setEmail] = useState("");
	let navigate = useNavigate();

	let user = getUserProfile();
	useEffect(() => {
		if (user) {
			return setEmail(user.email);
		} else logout();
		// eslint-disable-next-line
	}, [user]);

	const logout = () => {
		userLogout();
		navigate(routesService.getLoginRoute());
	};

	const menu = (
		<Menu>
			<Menu.Item className="d-flex align-items-center" key="2" icon={<LogoutOutlined />} onClick={logout}>
				Logout
			</Menu.Item>
		</Menu>
	);

	return (
		<Fragment>
			<Dropdown overlay={menu} trigger="click">
				<a href="#" className="d-flex align-items-center text-primary ant-dropdown-link">
					<>
						<UserOutlined className="mr-2" />
						<span className="mx-2">{email}</span>
						<DownOutlined className="ml-2" />
					</>
				</a>
			</Dropdown>
		</Fragment>
	);
};

export default UserBox;
